/* HTML5 display-role reset for older browsers */
@import url("https://fonts.googleapis.com/css?family=Open+Sans:100,200,300,400,500,600,700,800|Titillium+Web:100,200,300,400,500,600,700,800");
details,
footer,
header,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

html,
body,
div,
span,
h1,
h2,
h3,
h4,
h5,
h6,
p,
a,
img,
u,
i,
center,
ol,
ul,
li,
fieldset,
form,
label,
legend,
footer,
header,
menu,
nav,
section,
summary,
button {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-style: inherit;
  font-variant: inherit;
  font-weight: inherit;
  line-height: inherit;
  vertical-align: baseline;
  box-sizing: border-box;
}
html:focus,
body:focus,
div:focus,
span:focus,
h1:focus,
h2:focus,
h3:focus,
h4:focus,
h5:focus,
h6:focus,
p:focus,
a:focus,
img:focus,
u:focus,
i:focus,
center:focus,
ol:focus,
ul:focus,
li:focus,
fieldset:focus,
form:focus,
label:focus,
legend:focus,
footer:focus,
header:focus,
menu:focus,
nav:focus,
section:focus,
summary:focus,
button:focus {
  outline: none;
}

/* z-index catalog */
/**
   * @deprecated (in v6.23.0) Please use $font-weight-semibold instead
*/
.agl-ds-fontfamily01 {
  font-family: var(--font-family-01, "Titillium Web", sans-serif) !important;
}

.agl-ds-fontfamily02 {
  font-family: "Open Sans", sans-serif !important;
}

.agl-ds-default-colour {
  color: var(--c-neutral-01, #2b2e31);
}

.agl-ds-muted-colour {
  color: var(--c-neutral-02, #6b6d77);
}

.agl-ds-highlight-colour {
  color: var(--c-primary-01, #001cb0);
}

.agl-ds-inverse-colour {
  color: var(--c-neutral-08, #fff);
}

.agl-ds-secondary-highlight-colour {
  color: var(--c-secondary-04, #6031a6);
}

.agl-ds-error-colour {
  color: var(--c-error, #ce2a3e);
}

.primary-fill {
  fill: var(--c-primary-01, #001cb0);
}

.primary-stroke {
  stroke: var(--c-primary-01, #001cb0);
}

.secondary-02-fill {
  fill: var(--c-secondary-02, #f6a623);
}

.tertiary-02-fill {
  fill: var(--c-tertiary-02, #2caa18);
}

.neutral-01-fill {
  fill: var(--c-neutral-01, #2b2e31);
}

.neutral-03-fill {
  fill: var(--c-neutral-03, #a7a9b3);
}

.neutral-08-fill {
  fill: var(--c-neutral-08, #fff);
}

.neutral-03-stroke {
  stroke: var(--c-neutral-03, #a7a9b3);
}

.neutral-08-stroke {
  stroke: var(--c-neutral-08, #fff);
}

.error-fill {
  fill: var(--c-error, #ce2a3e);
}

.success-fill {
  fill: var(--c-success, #008000);
}

/* usage
.selector {
  color: red;

  @include agl-ds-screen-size('small') {
    color: blue;
  }
}
*/
/* Visually hidden content for assistive technologies (screen readers) only */
/* this needs to be a global class rather than a mixin/variable so it can be dynamically added to dom elements */
.sr-only {
  position: absolute !important;
  clip: rect(0, 0, 0, 0);
  margin: -1px;
  padding: 0 !important;
  border: 0 !important;
  height: 1px !important;
  width: 1px !important;
  overflow: hidden;
}

.hide {
  display: none;
}

/* specifically target IE11 */
/* controlled focus outline */
.grid-container {
  margin-right: auto;
  margin-left: auto;
}
.grid-container__no-margin {
  margin-right: 0;
  margin-left: 0;
}

.row {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
}

.row:not(.reverse) > div:first-child {
  padding-left: 0;
}

.row:not(.reverse) > div:last-child {
  padding-right: 0;
}

.row.reverse > div:first-child {
  padding-right: 0;
}

.row.reverse > div:last-child {
  padding-left: 0;
}

.row.reverse {
  flex-direction: row-reverse;
}

.col.reverse {
  flex-direction: column-reverse;
}

@media (min-width: 0) {
  .grid-container {
    width: 100%;
  }

  .col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-offset-0,
.col-sm-offset-1,
.col-sm-offset-2,
.col-sm-offset-3,
.col-sm-offset-4,
.col-sm-offset-5,
.col-sm-offset-6,
.col-sm-offset-7,
.col-sm-offset-8,
.col-sm-offset-9,
.col-sm-offset-10,
.col-sm-offset-11,
.col-sm-offset-12 {
    box-sizing: border-box;
    flex: 0 0 auto;
    padding-right: 8px;
    padding-left: 8px;
  }
}
@media (min-width: 0) and (min-width: 720px) {
  .col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-offset-0,
.col-sm-offset-1,
.col-sm-offset-2,
.col-sm-offset-3,
.col-sm-offset-4,
.col-sm-offset-5,
.col-sm-offset-6,
.col-sm-offset-7,
.col-sm-offset-8,
.col-sm-offset-9,
.col-sm-offset-10,
.col-sm-offset-11,
.col-sm-offset-12 {
    padding-right: 12px;
    padding-left: 12px;
  }
}
@media (min-width: 0) and (min-width: 992px) {
  .col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-offset-0,
.col-sm-offset-1,
.col-sm-offset-2,
.col-sm-offset-3,
.col-sm-offset-4,
.col-sm-offset-5,
.col-sm-offset-6,
.col-sm-offset-7,
.col-sm-offset-8,
.col-sm-offset-9,
.col-sm-offset-10,
.col-sm-offset-11,
.col-sm-offset-12 {
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media (min-width: 0) {
  .col-sm {
    flex-grow: 1;
    flex-basis: 0;
    max-width: 100%;
  }
}
@media (min-width: 0) {
  .col-sm-1 {
    flex-basis: 8.33333333%;
    max-width: 8.33333333%;
  }
}
@media (min-width: 0) {
  .col-sm-2 {
    flex-basis: 16.66666667%;
    max-width: 16.66666667%;
  }
}
@media (min-width: 0) {
  .col-sm-3 {
    flex-basis: 25%;
    max-width: 25%;
  }
}
@media (min-width: 0) {
  .col-sm-4 {
    flex-basis: 33.33333333%;
    max-width: 33.33333333%;
  }
}
@media (min-width: 0) {
  .col-sm-5 {
    flex-basis: 41.66666667%;
    max-width: 41.66666667%;
  }
}
@media (min-width: 0) {
  .col-sm-6 {
    flex-basis: 50%;
    max-width: 50%;
  }
}
@media (min-width: 0) {
  .col-sm-7 {
    flex-basis: 58.33333333%;
    max-width: 58.33333333%;
  }
}
@media (min-width: 0) {
  .col-sm-8 {
    flex-basis: 66.66666667%;
    max-width: 66.66666667%;
  }
}
@media (min-width: 0) {
  .col-sm-9 {
    flex-basis: 75%;
    max-width: 75%;
  }
}
@media (min-width: 0) {
  .col-sm-10 {
    flex-basis: 83.33333333%;
    max-width: 83.33333333%;
  }
}
@media (min-width: 0) {
  .col-sm-11 {
    flex-basis: 91.66666667%;
    max-width: 91.66666667%;
  }
}
@media (min-width: 0) {
  .col-sm-12 {
    flex-basis: 100%;
    max-width: 100%;
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 0) {
  .col-sm-offset-0 {
    margin-left: 0;
  }
}
@media (min-width: 0) {
  .col-sm-offset-1 {
    margin-left: 8.33333333%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-2 {
    margin-left: 16.66666667%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-3 {
    margin-left: 25%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-4 {
    margin-left: 33.33333333%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-5 {
    margin-left: 41.66666667%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-6 {
    margin-left: 50%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-7 {
    margin-left: 58.33333333%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-8 {
    margin-left: 66.66666667%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-9 {
    margin-left: 75%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-10 {
    margin-left: 83.33333333%;
  }
}
@media (min-width: 0) {
  .col-sm-offset-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 0) {
  .start-sm {
    justify-content: flex-start;
    text-align: start;
  }
}
@media (min-width: 0) {
  .center-sm {
    justify-content: center;
    text-align: center;
  }
}
@media (min-width: 0) {
  .end-sm {
    justify-content: flex-end;
    text-align: end;
  }
}
@media (min-width: 0) {
  .top-sm {
    align-items: flex-start;
  }
}
@media (min-width: 0) {
  .middle-sm {
    align-items: center;
  }
}
@media (min-width: 0) {
  .bottom-sm {
    align-items: flex-end;
  }
}
@media (min-width: 0) {
  .around-sm {
    justify-content: space-around;
  }
}
@media (min-width: 0) {
  .between-sm {
    justify-content: space-between;
  }
}
@media (min-width: 0) {
  .first-sm {
    order: -1;
  }
}
@media (min-width: 0) {
  .last-sm {
    order: 1;
  }
}
@media (min-width: 720px) {
  .grid-container {
    width: 100%;
    max-width: 943px;
  }

  .col-md,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-offset-0,
.col-md-offset-1,
.col-md-offset-2,
.col-md-offset-3,
.col-md-offset-4,
.col-md-offset-5,
.col-md-offset-6,
.col-md-offset-7,
.col-md-offset-8,
.col-md-offset-9,
.col-md-offset-10,
.col-md-offset-11,
.col-md-offset-12 {
    box-sizing: border-box;
    flex: 0 0 auto;
    padding-right: 12px;
    padding-left: 12px;
  }
}
@media (min-width: 720px) and (min-width: 992px) {
  .col-md,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-offset-0,
.col-md-offset-1,
.col-md-offset-2,
.col-md-offset-3,
.col-md-offset-4,
.col-md-offset-5,
.col-md-offset-6,
.col-md-offset-7,
.col-md-offset-8,
.col-md-offset-9,
.col-md-offset-10,
.col-md-offset-11,
.col-md-offset-12 {
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media (min-width: 720px) {
  .col-md {
    flex-grow: 1;
    flex-basis: 0;
    max-width: 100%;
  }
}
@media (min-width: 720px) {
  .col-md-1 {
    flex-basis: 8.33333333%;
    max-width: 8.33333333%;
  }
}
@media (min-width: 720px) {
  .col-md-2 {
    flex-basis: 16.66666667%;
    max-width: 16.66666667%;
  }
}
@media (min-width: 720px) {
  .col-md-3 {
    flex-basis: 25%;
    max-width: 25%;
  }
}
@media (min-width: 720px) {
  .col-md-4 {
    flex-basis: 33.33333333%;
    max-width: 33.33333333%;
  }
}
@media (min-width: 720px) {
  .col-md-5 {
    flex-basis: 41.66666667%;
    max-width: 41.66666667%;
  }
}
@media (min-width: 720px) {
  .col-md-6 {
    flex-basis: 50%;
    max-width: 50%;
  }
}
@media (min-width: 720px) {
  .col-md-7 {
    flex-basis: 58.33333333%;
    max-width: 58.33333333%;
  }
}
@media (min-width: 720px) {
  .col-md-8 {
    flex-basis: 66.66666667%;
    max-width: 66.66666667%;
  }
}
@media (min-width: 720px) {
  .col-md-9 {
    flex-basis: 75%;
    max-width: 75%;
  }
}
@media (min-width: 720px) {
  .col-md-10 {
    flex-basis: 83.33333333%;
    max-width: 83.33333333%;
  }
}
@media (min-width: 720px) {
  .col-md-11 {
    flex-basis: 91.66666667%;
    max-width: 91.66666667%;
  }
}
@media (min-width: 720px) {
  .col-md-12 {
    flex-basis: 100%;
    max-width: 100%;
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 720px) {
  .col-md-offset-0 {
    margin-left: 0;
  }
}
@media (min-width: 720px) {
  .col-md-offset-1 {
    margin-left: 8.33333333%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-2 {
    margin-left: 16.66666667%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-3 {
    margin-left: 25%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-4 {
    margin-left: 33.33333333%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-5 {
    margin-left: 41.66666667%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-6 {
    margin-left: 50%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-7 {
    margin-left: 58.33333333%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-8 {
    margin-left: 66.66666667%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-9 {
    margin-left: 75%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-10 {
    margin-left: 83.33333333%;
  }
}
@media (min-width: 720px) {
  .col-md-offset-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 720px) {
  .start-md {
    justify-content: flex-start;
    text-align: start;
  }
}
@media (min-width: 720px) {
  .center-md {
    justify-content: center;
    text-align: center;
  }
}
@media (min-width: 720px) {
  .end-md {
    justify-content: flex-end;
    text-align: end;
  }
}
@media (min-width: 720px) {
  .top-md {
    align-items: flex-start;
  }
}
@media (min-width: 720px) {
  .middle-md {
    align-items: center;
  }
}
@media (min-width: 720px) {
  .bottom-md {
    align-items: flex-end;
  }
}
@media (min-width: 720px) {
  .around-md {
    justify-content: space-around;
  }
}
@media (min-width: 720px) {
  .between-md {
    justify-content: space-between;
  }
}
@media (min-width: 720px) {
  .first-md {
    order: -1;
  }
}
@media (min-width: 720px) {
  .last-md {
    order: 1;
  }
}
@media (min-width: 992px) {
  .grid-container {
    width: 100%;
    max-width: 1216px;
  }

  .col-lg,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-offset-0,
.col-lg-offset-1,
.col-lg-offset-2,
.col-lg-offset-3,
.col-lg-offset-4,
.col-lg-offset-5,
.col-lg-offset-6,
.col-lg-offset-7,
.col-lg-offset-8,
.col-lg-offset-9,
.col-lg-offset-10,
.col-lg-offset-11,
.col-lg-offset-12 {
    box-sizing: border-box;
    flex: 0 0 auto;
    padding-right: 16px;
    padding-left: 16px;
  }

  .col-lg {
    flex-grow: 1;
    flex-basis: 0;
    max-width: 100%;
  }

  .col-lg-1 {
    flex-basis: 8.33333333%;
    max-width: 8.33333333%;
  }

  .col-lg-2 {
    flex-basis: 16.66666667%;
    max-width: 16.66666667%;
  }

  .col-lg-3 {
    flex-basis: 25%;
    max-width: 25%;
  }

  .col-lg-4 {
    flex-basis: 33.33333333%;
    max-width: 33.33333333%;
  }

  .col-lg-5 {
    flex-basis: 41.66666667%;
    max-width: 41.66666667%;
  }

  .col-lg-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .col-lg-7 {
    flex-basis: 58.33333333%;
    max-width: 58.33333333%;
  }

  .col-lg-8 {
    flex-basis: 66.66666667%;
    max-width: 66.66666667%;
  }

  .col-lg-9 {
    flex-basis: 75%;
    max-width: 75%;
  }

  .col-lg-10 {
    flex-basis: 83.33333333%;
    max-width: 83.33333333%;
  }

  .col-lg-11 {
    flex-basis: 91.66666667%;
    max-width: 91.66666667%;
  }

  .col-lg-12 {
    flex-basis: 100%;
    max-width: 100%;
    padding-right: 0;
    padding-left: 0;
  }

  .col-lg-offset-0 {
    margin-left: 0;
  }

  .col-lg-offset-1 {
    margin-left: 8.33333333%;
  }

  .col-lg-offset-2 {
    margin-left: 16.66666667%;
  }

  .col-lg-offset-3 {
    margin-left: 25%;
  }

  .col-lg-offset-4 {
    margin-left: 33.33333333%;
  }

  .col-lg-offset-5 {
    margin-left: 41.66666667%;
  }

  .col-lg-offset-6 {
    margin-left: 50%;
  }

  .col-lg-offset-7 {
    margin-left: 58.33333333%;
  }

  .col-lg-offset-8 {
    margin-left: 66.66666667%;
  }

  .col-lg-offset-9 {
    margin-left: 75%;
  }

  .col-lg-offset-10 {
    margin-left: 83.33333333%;
  }

  .col-lg-offset-11 {
    margin-left: 91.66666667%;
  }

  .start-lg {
    justify-content: flex-start;
    text-align: start;
  }

  .center-lg {
    justify-content: center;
    text-align: center;
  }

  .end-lg {
    justify-content: flex-end;
    text-align: end;
  }

  .top-lg {
    align-items: flex-start;
  }

  .middle-lg {
    align-items: center;
  }

  .bottom-lg {
    align-items: flex-end;
  }

  .around-lg {
    justify-content: space-around;
  }

  .between-lg {
    justify-content: space-between;
  }

  .first-lg {
    order: -1;
  }

  .last-lg {
    order: 1;
  }
}
.hidden {
  display: none !important;
}

@media (min-width: 0) {
  .visible-sm {
    display: block !important;
  }

  .visible-sm-only {
    display: block !important;
  }

  .visible-md-only {
    display: none !important;
  }

  .visible-lg-only {
    display: none !important;
  }

  .hidden-sm {
    display: none !important;
  }
}
@media (min-width: 720px) {
  .visible-md {
    display: block !important;
  }

  .visible-sm-only {
    display: none !important;
  }

  .visible-md-only {
    display: block !important;
  }

  .visible-lg-only {
    display: none !important;
  }

  .hidden-md {
    display: none !important;
  }
}
@media (min-width: 992px) {
  .visible-lg {
    display: block !important;
  }

  .visible-sm-only {
    display: none !important;
  }

  .visible-md-only {
    display: none !important;
  }

  .visible-lg-only {
    display: block !important;
  }

  .hidden-lg {
    display: none !important;
  }
}
.remove-horizonal-padding {
  padding-left: 0;
  padding-right: 0;
}

:host {
  display: inline;
}

.agl-ds-using-mouse {
  box-shadow: none !important;
}

.button {
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  letter-spacing: 0;
  margin-bottom: 0;
  display: inline-flex;
  width: 100%;
  height: 56px;
  line-height: 24px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 28px;
  align-items: center;
  justify-content: center;
  text-rendering: auto;
  letter-spacing: normal;
  text-shadow: none;
  cursor: pointer;
}
@media (min-width: 0) {
  .button {
    line-height: 1.3125rem;
    font-size: 0.875rem;
  }
}
@media (min-width: 720px) {
  .button {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
@media (min-width: 992px) {
  .button {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.button:focus {
  outline: none;
  box-shadow: 0 0 1px 3px var(--c-focus-ring-colour, #fc9fe8);
}
.button.agl-ds-sm {
  height: 40px;
  min-width: auto;
  font-size: 0.875rem;
  font-weight: 400;
}
.button-icon {
  padding-top: 6px;
  margin-left: 16px;
}
.button-icon--left {
  margin-left: 0;
  margin-right: 16px;
}
.button-icon--center {
  margin: 0;
}
.button.agl-ds-primary--default {
  min-width: 90px;
  background-color: var(--c-primary-01, #001cb0);
  border: 2px solid var(--c-primary-01, #001cb0);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--default {
    max-width: 288px;
  }
}
.button.agl-ds-primary--default:focus {
  background-color: var(--c-primary-01, #001cb0);
  border: 2px solid var(--c-primary-01, #001cb0);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
.button.agl-ds-primary--default:hover {
  background-color: var(--c-primary-01-tint-80, #3349c0);
  border: 2px solid var(--c-primary-01-tint-80, #3349c0);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
.button.agl-ds-primary--default:active {
  background-color: var(--c-primary-01-shade-20, #00168d);
  border: 2px solid rgba(var(--c-primary-01-shade-20-rgb, 0, 22, 141), 0.8);
  color: var(--c-primary-01-tint-20, #ccd2ef);
  text-decoration: none;
}
.button.agl-ds-primary--default-at-rest {
  min-width: 90px;
  background-color: var(--c-primary-01, #001cb0);
  border: 2px solid var(--c-primary-01, #001cb0);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--default-at-rest {
    max-width: 288px;
  }
}
.button.agl-ds-primary--default-focus {
  min-width: 90px;
  background-color: var(--c-primary-01, #001cb0);
  border: 2px solid var(--c-primary-01, #001cb0);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--default-focus {
    max-width: 288px;
  }
}
.button.agl-ds-primary--default-hover {
  min-width: 90px;
  background-color: var(--c-primary-01-tint-80, #3349c0);
  border: 2px solid var(--c-primary-01-tint-80, #3349c0);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--default-hover {
    max-width: 288px;
  }
}
.button.agl-ds-primary--default-active {
  min-width: 90px;
  background-color: var(--c-primary-01-shade-20, #00168d);
  border: 2px solid rgba(var(--c-primary-01-shade-20-rgb, 0, 22, 141), 0.8);
  color: var(--c-primary-01-tint-20, #ccd2ef);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--default-active {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--default {
  min-width: 90px;
  background-color: transparent;
  border: 2px solid var(--c-primary-01, #001cb0);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--default {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--default:focus {
  background-color: transparent;
  border: 2px solid var(--c-primary-01, #001cb0);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
.button.agl-ds-secondary--default:hover {
  background-color: var(--c-primary-01-tint-20, #ccd2ef);
  border: 2px solid var(--c-primary-01-tint-20, #ccd2ef);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
.button.agl-ds-secondary--default:active {
  background-color: var(--c-primary-01-tint-30, #b3bbe7);
  border: 2px solid var(--c-primary-01-tint-30, #b3bbe7);
  color: var(--c-primary-01-tint-80, #3349c0);
  text-decoration: none;
}
.button.agl-ds-secondary--default-at-rest {
  min-width: 90px;
  background-color: transparent;
  border: 2px solid var(--c-primary-01, #001cb0);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--default-at-rest {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--default-focus {
  min-width: 90px;
  background-color: transparent;
  border: 2px solid var(--c-primary-01, #001cb0);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--default-focus {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--default-hover {
  min-width: 90px;
  background-color: var(--c-primary-01-tint-20, #ccd2ef);
  border: 2px solid var(--c-primary-01-tint-20, #ccd2ef);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--default-hover {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--default-active {
  min-width: 90px;
  background-color: var(--c-primary-01-tint-30, #b3bbe7);
  border: 2px solid var(--c-primary-01-tint-30, #b3bbe7);
  color: var(--c-primary-01-tint-80, #3349c0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--default-active {
    max-width: 288px;
  }
}
.button.agl-ds-tertiary--default {
  width: auto;
  padding: 0 24px;
  background-color: transparent;
  border: 2px solid transparent;
  color: var(--c-primary-01, #001cb0);
  text-decoration: underline;
}
.button.agl-ds-tertiary--default:focus {
  background-color: transparent;
  border: 2px solid transparent;
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
.button.agl-ds-tertiary--default:hover {
  background-color: var(--c-primary-01-tint-20, #ccd2ef);
  border: 2px solid var(--c-primary-01-tint-20, #ccd2ef);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
.button.agl-ds-tertiary--default:active {
  background-color: var(--c-primary-01-tint-30, #b3bbe7);
  border: 2px solid var(--c-primary-01-tint-30, #b3bbe7);
  color: var(--c-primary-01-tint-80, #3349c0);
  text-decoration: none;
}
.button.agl-ds-tertiary--default-at-rest {
  width: auto;
  padding: 0 24px;
  background-color: transparent;
  border: 2px solid transparent;
  color: var(--c-primary-01, #001cb0);
  text-decoration: underline;
}
.button.agl-ds-tertiary--default-focus {
  width: auto;
  padding: 0 24px;
  background-color: transparent;
  border: 2px solid transparent;
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
.button.agl-ds-tertiary--default-hover {
  width: auto;
  padding: 0 24px;
  background-color: var(--c-primary-01-tint-20, #ccd2ef);
  border: 2px solid var(--c-primary-01-tint-20, #ccd2ef);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
.button.agl-ds-tertiary--default-active {
  width: auto;
  padding: 0 24px;
  background-color: var(--c-primary-01-tint-30, #b3bbe7);
  border: 2px solid var(--c-primary-01-tint-30, #b3bbe7);
  color: var(--c-primary-01-tint-80, #3349c0);
  text-decoration: none;
}
.button.agl-ds-primary--reverse {
  min-width: 90px;
  background-color: var(--c-neutral-08, #fff);
  border: 2px solid var(--c-neutral-08, #fff);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--reverse {
    max-width: 288px;
  }
}
.button.agl-ds-primary--reverse:focus {
  background-color: var(--c-neutral-08, #fff);
  border: 2px solid var(--c-neutral-08, #fff);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
.button.agl-ds-primary--reverse:hover {
  background-color: var(--c-primary-01-tint-20, #ccd2ef);
  border: 2px solid var(--c-primary-01-tint-20, #ccd2ef);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
.button.agl-ds-primary--reverse:active {
  background-color: var(--c-primary-01-tint-30, #b3bbe7);
  border: 2px solid var(--c-primary-01-tint-30, #b3bbe7);
  color: var(--c-primary-01-tint-80, #3349c0);
  text-decoration: none;
}
.button.agl-ds-primary--reverse-at-rest {
  min-width: 90px;
  background-color: var(--c-neutral-08, #fff);
  border: 2px solid var(--c-neutral-08, #fff);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--reverse-at-rest {
    max-width: 288px;
  }
}
.button.agl-ds-primary--reverse-focus {
  min-width: 90px;
  background-color: var(--c-neutral-08, #fff);
  border: 2px solid var(--c-neutral-08, #fff);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--reverse-focus {
    max-width: 288px;
  }
}
.button.agl-ds-primary--reverse-hover {
  min-width: 90px;
  background-color: var(--c-primary-01-tint-20, #ccd2ef);
  border: 2px solid var(--c-primary-01-tint-20, #ccd2ef);
  color: var(--c-primary-01, #001cb0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--reverse-hover {
    max-width: 288px;
  }
}
.button.agl-ds-primary--reverse-active {
  min-width: 90px;
  background-color: var(--c-primary-01-tint-30, #b3bbe7);
  border: 2px solid var(--c-primary-01-tint-30, #b3bbe7);
  color: var(--c-primary-01-tint-80, #3349c0);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-primary--reverse-active {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--reverse {
  min-width: 90px;
  background-color: transparent;
  border: 2px solid var(--c-neutral-08, #fff);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--reverse {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--reverse:focus {
  background-color: transparent;
  border: 2px solid var(--c-neutral-08, #fff);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
.button.agl-ds-secondary--reverse:hover {
  background-color: rgba(var(--c-neutral-08-rgb, 255, 255, 255), 0.2);
  border: 2px solid transparent;
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
.button.agl-ds-secondary--reverse:active {
  background-color: rgba(var(--c-neutral-08-rgb, 255, 255, 255), 0.3);
  border: 2px solid transparent;
  color: var(--c-primary-01-tint-20, #ccd2ef);
  text-decoration: none;
}
.button.agl-ds-secondary--reverse-at-rest {
  min-width: 90px;
  background-color: transparent;
  border: 2px solid var(--c-neutral-08, #fff);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--reverse-at-rest {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--reverse-focus {
  min-width: 90px;
  background-color: transparent;
  border: 2px solid var(--c-neutral-08, #fff);
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--reverse-focus {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--reverse-hover {
  min-width: 90px;
  background-color: rgba(var(--c-neutral-08-rgb, 255, 255, 255), 0.2);
  border: 2px solid transparent;
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--reverse-hover {
    max-width: 288px;
  }
}
.button.agl-ds-secondary--reverse-active {
  min-width: 90px;
  background-color: rgba(var(--c-neutral-08-rgb, 255, 255, 255), 0.3);
  border: 2px solid transparent;
  color: var(--c-primary-01-tint-20, #ccd2ef);
  text-decoration: none;
}
@media (min-width: 720px) {
  .button.agl-ds-secondary--reverse-active {
    max-width: 288px;
  }
}
.button.agl-ds-tertiary--reverse {
  width: auto;
  padding: 0 24px;
  background-color: transparent;
  border: 2px solid transparent;
  color: var(--c-neutral-08, #fff);
  text-decoration: underline;
}
.button.agl-ds-tertiary--reverse:focus {
  background-color: transparent;
  border: 2px solid transparent;
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
.button.agl-ds-tertiary--reverse:hover {
  background-color: rgba(var(--c-neutral-08-rgb, 255, 255, 255), 0.2);
  border: 2px solid transparent;
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
.button.agl-ds-tertiary--reverse:active {
  background-color: rgba(var(--c-neutral-08-rgb, 255, 255, 255), 0.3);
  border: 2px solid transparent;
  color: var(--c-primary-01-tint-20, #ccd2ef);
  text-decoration: none;
}
.button.agl-ds-tertiary--reverse-at-rest {
  width: auto;
  padding: 0 24px;
  background-color: transparent;
  border: 2px solid transparent;
  color: var(--c-neutral-08, #fff);
  text-decoration: underline;
}
.button.agl-ds-tertiary--reverse-focus {
  width: auto;
  padding: 0 24px;
  background-color: transparent;
  border: 2px solid transparent;
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
.button.agl-ds-tertiary--reverse-hover {
  width: auto;
  padding: 0 24px;
  background-color: rgba(var(--c-neutral-08-rgb, 255, 255, 255), 0.2);
  border: 2px solid transparent;
  color: var(--c-neutral-08, #fff);
  text-decoration: none;
}
.button.agl-ds-tertiary--reverse-active {
  width: auto;
  padding: 0 24px;
  background-color: rgba(var(--c-neutral-08-rgb, 255, 255, 255), 0.3);
  border: 2px solid transparent;
  color: var(--c-primary-01-tint-20, #ccd2ef);
  text-decoration: none;
}

.icon-left {
  flex-direction: row-reverse;
}

.icon-center--sm {
  min-width: 40px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.icon-center--lg {
  min-width: 56px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.rotate-icon-apply {
  -webkit-animation-name: rotate-apply;
          animation-name: rotate-apply;
  -webkit-animation-duration: 300ms;
          animation-duration: 300ms;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}
@-webkit-keyframes rotate-apply {
  0% {
    transform: rotate(0deg);
    transform-origin: center;
  }
  100% {
    transform: rotate(180deg);
    transform-origin: center;
  }
}
@keyframes rotate-apply {
  0% {
    transform: rotate(0deg);
    transform-origin: center;
  }
  100% {
    transform: rotate(180deg);
    transform-origin: center;
  }
}

.rotate-icon-remove {
  -webkit-animation-name: rotate-remove;
          animation-name: rotate-remove;
  -webkit-animation-duration: 300ms;
          animation-duration: 300ms;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}
@-webkit-keyframes rotate-remove {
  0% {
    transform: rotate(180deg);
    transform-origin: center;
  }
  100% {
    transform: rotate(0deg);
    transform-origin: center;
  }
}
@keyframes rotate-remove {
  0% {
    transform: rotate(180deg);
    transform-origin: center;
  }
  100% {
    transform: rotate(0deg);
    transform-origin: center;
  }
}

.remove-underline {
  text-decoration: none !important;
}